import React from 'react';

import {
  Box,
  Button,
  Checkbox,
  Flex,
  Image,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from '@chakra-ui/react';
import { FaChevronDown } from 'react-icons/fa6';

import { TChainOption } from '@/container/pages/Defi';
import BaseImage from '@/dapp-sdk-v2/components/Image';

export type TCategoryDropdownProps = {
  options: TChainOption[];
  selectedChain?: TChainOption;
  onSelect: <T>(option: TChainOption, value: T) => void;
  placeholder?: string;
  isCheckbox?: boolean;
};

export default function ChainDropdown({
  options,
  selectedChain,
  onSelect,
  placeholder = '',
  isCheckbox = false,
}: TCategoryDropdownProps) {
  return (
    <Flex alignItems="center" gap={4}>
      <Box
        pos="relative"
        borderWidth="1px"
        borderRadius={'8px'}
        borderColor={'#d3d3d3'}
        minWidth={'100px'}
      >
        <Menu closeOnSelect={!isCheckbox}>
          <MenuButton
            as={Button}
            h={{ base: '28px', lg: '38px' }}
            rightIcon={<FaChevronDown />}
            leftIcon={
              !isCheckbox ? (
                <BaseImage
                  height={20}
                  width={20}
                  src={selectedChain?.icon || ''}
                  alt={selectedChain?.label || ''}
                />
              ) : undefined
            }
            w="100%"
            textAlign="left"
            _hover={{
              bg: 'backgroundSecondary',
            }}
            borderRadius="8px"
            bg="backgroundSecondary"
            color="textPrimary"
            fontWeight="500"
            fontSize={{ base: '12px', lg: '14px' }}
          >
            <Flex
              alignItems="center"
              justify="space-between"
              mr={{ base: '1rem', lg: 0 }}
              flex={1}
              gap={2}
              width="fit-content"
            >
              {selectedChain?.label || placeholder}
            </Flex>
          </MenuButton>
          <MenuList
            transformOrigin="top !important"
            w={{
              base: '180px',
              sm: '100%',
            }}
            border="1px solid #AEDFCA"
            borderColor="seperator"
            bg="backgroundSecondary"
            fontSize="14px"
            fontWeight="400"
          >
            {options.map((option: TChainOption) => {
              return (
                <MenuItem
                  key={option.id}
                  id={option.id}
                  padding={2}
                  marginBottom={1}
                  onClick={(e) => {
                    e.preventDefault();
                    onSelect(option, !option.checked);
                  }}
                  _focus={{
                    bg: 'backgroundPrimary',
                  }}
                  _hover={{
                    bg: 'backgroundPrimary',
                  }}
                >
                  <Flex
                    justifyContent="space-between"
                    w="100%"
                    alignItems="center"
                    pl={2}
                  >
                    <Flex alignItems="center" gap="8px" flex={1}>
                      {isCheckbox ? (
                        <>
                          <Box overflow="hidden" pos="relative">
                            <Checkbox
                              size="lg"
                              isChecked={option.checked}
                              _checked={{
                                '& .chakra-checkbox__control': {
                                  background: '#075A5A',
                                  borderColor: '#075A5A',
                                },
                              }}
                              onChange={(e) =>
                                onSelect(option, !option.checked)
                              }
                            />
                          </Box>

                          <Flex
                            justify="space-between"
                            flex={1}
                            alignItems="center"
                            gap={2}
                          >
                            <Box flex={1} fontSize={14}>
                              {option.label}
                            </Box>
                          </Flex>
                        </>
                      ) : (
                        <>
                          <BaseImage
                            height={20}
                            width={20}
                            src={option.icon || ''}
                            alt={option.label}
                          />
                          <Flex
                            justify="space-between"
                            flex={1}
                            alignItems="center"
                            gap={2}
                          >
                            <Box flex={1} fontSize={14}>
                              {option.label}
                            </Box>
                          </Flex>
                        </>
                      )}
                    </Flex>
                  </Flex>
                </MenuItem>
              );
            })}
          </MenuList>
        </Menu>
      </Box>
    </Flex>
  );
}
